<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-page-header
        style="border: 1px solid rgb(235, 237, 240);"
        title="信用证付款"
        @back="() => $router.back()">
      </a-page-header>
      <a-form layout="inline">
        <a-row :gutter="48" style="margin: 10px">
          <a-col :md="2" :sm="24" v-if="true">
            <a-button type="primary" @click="handleAdd">新建</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="lc_amount_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }} （{{ $Dictionaries.currency[record.lc_amount_currency] || '' }}）
      </div>
      <div slot="margin_amount_render" slot-scope="text, record" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(4) | numberFormat }}（{{ $Dictionaries.currency[record.margin_amount_currency] || '' }}）
      </div>
      <div slot="margin_interest_rate_render" slot-scope="text" style="text-align: right; min-width: 90px; max-width: 200px">
        {{ (text / 1).toFixed(2) | numberFormat }} %
      </div>
      <span slot="approval_needed" slot-scope="text">
        <span class="desc">{{ text ? '是' : '否' }}</span>
      </span>
      <span slot="is_lc_acceptanced" slot-scope="text, item">
        <a-popconfirm
          title="确定承兑吗?"
          :disabled="text"
          @confirm="() => doAcceptance(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_lc_acceptanced" :disabled="item.is_lc_acceptanced"/>
        </a-popconfirm>
      </span>
      <span slot="is_audited" slot-scope="text, item">
        <a-popconfirm
          :title="auditTitle"
          @confirm="() => doAudit(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_audited"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider type="vertical" v-if="!record.is_audited"/>
          <a @click="handleEdit(record)" v-if="!record.is_audited">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.is_lc_acceptanced && record.is_audited"/>
          <a @click="handleAcceptance(record)" v-if="record.is_lc_acceptanced && record.is_audited">承兑</a>
          <a-divider type="vertical" v-if="record.is_lc_acceptanced && record.is_audited"/>
          <a @click="handleLcCost(record)" v-if="record.is_lc_acceptanced && record.is_audited">成本</a>
        </template>
      </span>
    </s-table>
    <lc-issue-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <lc-cost-form
      ref="createLcCostModal"
      v-if="lcCostVisible"
      :visible="lcCostVisible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddLcCostCancel"
      @ok="handleLcCostOk"
    />
    <archived-form
      ref="archivedModal"
      v-if="archived_visible"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import LcIssueForm from '../modules/LcIssueForm'
import LcCostForm from '../modules/LcCostForm'
import {
  credit_letter_archived,
  lc_application_list,
  lc_issuance_list,
  lc_issuance_create,
  lc_issuance_update,
  lc_issuance_delete, lc_cost_create, lc_cost_update
} from '@/api/trade_credit_letter'

export default {
  name: 'TableList',
  components: {
    STable,
    LcIssueForm,
    LcCostForm
  },
  data () {
    return {
      approval_again: false,
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      lcCostVisible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '采销全流程',
          dataIndex: 'project',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '业务号',
          dataIndex: 'business_no',
          width: 150,
          ellipsis: true
        },
        {
          title: '开证行',
          dataIndex: 'issuing_bank',
          width: 180,
          ellipsis: true
        },
        {
          title: '代开银行',
          dataIndex: 'debtor_bank',
          width: 180,
          ellipsis: true
        },
        {
          title: '上游客户',
          dataIndex: 'beneficiary',
          width: 180,
          ellipsis: true
        },
        {
          title: '开证日',
          dataIndex: 'issue_date',
          width: 120,
          ellipsis: true,
          customRender: (text) => text === '1970-01-01' ? '' : text
        },
        {
          title: '开证金额',
          dataIndex: 'lc_amount',
          scopedSlots: { customRender: 'lc_amount_render' },
          align: 'right',
          width: 160,
          ellipsis: true
        },
        {
          title: '溢短装（%）',
          dataIndex: 'more_less_clause',
          width: 140,
          align: 'right',
          ellipsis: true
        },
        {
          title: '保证金金额',
          dataIndex: 'margin_amount',
          scopedSlots: { customRender: 'margin_amount_render' },
          align: 'right',
          width: 180,
          ellipsis: true
        },
        {
          title: '保证金存入日期',
          dataIndex: 'margin_deposit_date',
          width: 180,
          ellipsis: true,
          align: 'center',
          customRender: (text) => text === '1970-01-01' ? '' : text
        },
        {
          title: '保证金到期日',
          dataIndex: 'margin_maturity_date',
          width: 180,
          ellipsis: true,
          align: 'center',
          customRender: (text) => text === '1970-01-01' ? '' : text
        },
        {
          title: '保证金利率',
          dataIndex: 'margin_interest_rate',
          scopedSlots: { customRender: 'margin_interest_rate_render' },
          align: 'right',
          width: 120,
          ellipsis: true
        },
        {
          title: '是否到期可用',
          dataIndex: 'is_available_at_expiry',
          ellipsis: true,
          align: 'center',
          width: 120,
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '信用证种类',
          dataIndex: 'lc_type',
          align: 'center',
          width: 100,
          customRender: (text) => this.$Dictionaries.trade_lc_types[text] || '无'
        },
        {
          title: '期限（天）',
          dataIndex: 'lc_tenor',
          width: 150,
          align: 'right',
          ellipsis: true
        },
        {
          title: '是否已承兑',
          dataIndex: 'is_lc_acceptanced',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'is_lc_acceptanced' }
        },
        {
          title: '是否已核验',
          dataIndex: 'is_audited',
          ellipsis: true,
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'is_audited' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return lc_issuance_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    this.queryParam['lc_application_id'] = this.$route.query.lc_application_id
  },
  mounted () {
    this.loadLcApplicationData()
  },
  computed: {
    auditTitle () {
      return (item) => item ? '确定重新启动核验吗？' : '确定已经通过核验吗？'
    }
  },
  methods: {
    loadLcApplicationData () {
      lc_application_list({ id: this.$route.query.lc_application_id })
        .then(res => {
          this.mdl = res.data.entries[0] || []
          console.log('信用证开始', this.mdl)
        })
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      this.$router.push({ path: '/trade/lc_issue/' + record.id + '/attachment', query: { project: record.project, business_no: record.business_no } })
    },
    handleEdit (record) {
      this.$router.push({ path: '/trade/lc_issue/' + record.id, query: { lc_application_id: this.$route.query.lc_application_id } })
    },
    doAcceptance (record) {
      // 去承兑
      lc_issuance_update({ is_lc_acceptanced: !record.is_lc_acceptanced }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    doAudit (record) {
      // 去承兑
      lc_issuance_update({ is_audited: !record.is_audited }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleAcceptance (record) {
      this.$router.push({ path: '/trade/lc_issue/' + record.id + '/acceptance', query: { lc_application_id: this.$route.query.lc_application_id } })
    },
    handleLcCost (record) {
      console.log('chengben', record)
      this.lcCostVisible = true
      this.mdl = record
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      this.mdl = { business_no: year + '' + month + '' + day + '' + hours, ...record }
    },
    handleDelete (record) {
      lc_issuance_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (data) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
          // 新增
          values = { ...values, ...data }
          values['lc_application_id'] = this.$route.query.lc_application_id
          lc_issuance_create(values).then(res => {
            this.visible = false
            this.confirmLoading = false
            // 重置表单数据
            form.resetFields()
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          credit_letter_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    handleAddLcCostCancel () {
      this.lcCostVisible = false
      const form = this.$refs.createLcCostModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleLcCostOk (id) {
      const form = this.$refs.createLcCostModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          if (id === undefined) {
            values['lc_issuance_id'] = this.mdl['id']
            lc_cost_create(values).then(res => {
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
                this.mdl = undefined
              }
            }).finally(() => {
              this.lcCostVisible = false
              this.confirmLoading = false
            })
          } else {
            console.log('修改')
            lc_cost_update(values, id).then(res => {
              if (res.code === 1000) {
                this.$refs.table.refresh()
                this.mdl = undefined
              }
            }).finally(() => {
              this.lcCostVisible = false
              this.confirmLoading = false
            })
          }
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
